import { Color, Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

import { ReportRowType } from '@features/reports/types/reportRowType'

const reportsPdfRowVariantStyles = StyleSheet.create({
  headerOrFooter: {
    backgroundColor: Color.Black,
  },
  group: {
    backgroundColor: Color.Grey200,
  },
})

export const getRowByTypeStyles = (type: ReportRowType, shouldApplyBottomMargin: boolean, isLastItem: boolean) => {
  switch (type) {
    case ReportRowType.Header:
    case ReportRowType.Footer:
      return [reportsPdfRowVariantStyles.headerOrFooter, ...(!isLastItem ? [{ marginBottom: Spacing.S20 }] : [])]
    case ReportRowType.Group:
      return [
        reportsPdfRowVariantStyles.group,
        ...(shouldApplyBottomMargin && !isLastItem ? [{ marginBottom: Spacing.S20 }] : []),
      ]
    default:
      return {}
  }
}
